module.exports = __webpack_public_path__ + "img/assembly-cp-mini-logo.52851e2b.png";